export default {
  downloadBanner: {
    title: "RC CITY веб-тиркемесин смартфонуңузга орнотуңуз",
    description:
      "Орнотуу ыкмасын тандап, сервиске телефондон кадимки мобилдик тиркеме сыяктуу эле кирип колдонуңуз",
    iosButton: "iOS үчүн",
    androidButton: "Android үчүн",
    imageAlt: "Тиркемеси бар телефон",
  },
  applicationAdvantages: {
    title:
      "RC CITY веб-тиркемеси – бул веб-сайттын жана мобилдик тиркеменин негизги артыкчылыктарынын мыкты айкалышы",
    advantages: {
      0: {
        title: "Экранга орнотуу",
        description:
          "Сайттын бардык функцияларына түз үй экраныңыздан тез жана ыңгайлуу жеткиликтүү болуңуз.",
      },
      1: {
        title: "Салмагы 1 Мбдан аз",
        description:
          "Курсуңуздун эс тутумун үнөмдөйт жана аз ресурстарды талап кылат.",
      },
      2: {
        title: "Толук экран режими",
        description:
          "Дарек тилкесисиз жана браузер элементтерисиз ачылат, бардык түзмөктөргө ылайыкташат.",
      },
      3: {
        title: "Иштетүүдө жаңыртылат",
        description:
          "Google Play же App Store аркылуу жаңыртууну жүктөп алуу зарыл эмес.",
      },
      4: {
        title: "Тез жүктөлөт",
        description:
          "Жүктөө башталган учурдан биринчи элемент көрсөтүлгөнгө чейин 1 секунддан ашпайт.",
      },
      5: {
        title: "Оффлайн жеткиликтүүлүк",
        description:
          "Айрым маалыматтарды кэшке сактап, интернет жок учурда да көрсөтө алат.",
      },
      6: {
        title: "Фондук режим",
        description:
          "Маалыматтарды синхрондоштуруу же push-билдирмелерди алуу үчүн тиркемени ачык кармоонун кажети жок.",
      },
      7: {
        title: "Жылмакай анимация",
        description:
          "Жооп кайтаруу ылдам жана нативдик мобилдик тиркеме сыяктуу иштейт.",
      },
      8: {
        title: "Энергияны үнөмдөө",
        description:
          "Аз энергия колдонот, бул батареянын иштөө мөөнөтүн узартат.",
      },
    },
  },

  instructionIOS: {
    title: "RC CITY веб-тиркемесин iOSко кантип орнотуу керек",
    steps: {
      first: {
        text: "Телефонуңуздан Safari браузери аркылуу <a href='https://rc.city/' target='_blank'>rc.city</a> сайтына кириңиз жана «Бөлүшүү» иконкасын басыңыз.",
      },
      second: {
        text: "Ачылган терезеде ылдый жылдырып, «Башкы экранга» параметрин тандаңыз.",
      },
      third: {
        text: "Жогорку оң бурчтагы «Кошуу» баскычын басыңыз — RC CITY иконкасы башкы экранда пайда болот.",
      },
    },
  },

  instructionAndroid: {
    title: "RC CITY веб-тиркемесин Androidге кантип орнотуу керек",
    description: {
      part1: "Телефондон басыңыз",
      installButton: "«Androidге орнотуу»",
      part2: "же браузер аркылуу кол менен төмөнкү кадамдарды аткарыңыз.",
    },
    steps: {
      first: {
        text: "Телефондон <a href='https://rc.city/' target='_blank'>rc.city</a> сайтын ачыңыз жана жогорку оң бурчтагы «Дагы» иконкасын басыңыз.",
      },
      second: {
        text: "Ачылган менюдан ылдый жылдырып, «Башкы экранга кошуу» дегенди тандаңыз.",
      },
      third: {
        text: "Модалдык терезеде «Орнотуу» баскычын басыңыз — RC CITY иконкасы башкы экранда пайда болот.",
      },
    },
  },

  pwaHelp: {
    title: "Орнотууда кыйынчылык болуп жатабы?",
    description:
      'Техникалык колдоо кызматына <a href="https://t.me/rccity" target="_blank">Telegram</a> аркылуу же <a href="mailto:hello@rc.city" target="_blank">hello@rc.city</a> электрондук почтасы аркылуу кайрылыңыз',
  },
};
